import { AnimatePresence, motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { CheckCircle2, XCircle, Send, ArrowUpRight, UserCheck } from "lucide-react";

// Floating action pill that overlays the table so selecting rows never shifts the layout.
export const BulkToolbar = ({ selected, members, onBulk, onAssign, onClear }) => (
  <AnimatePresence>
    {selected.size > 0 && (
      <motion.div initial={{ opacity: 0, y: 14, x: "-50%" }} animate={{ opacity: 1, y: 0, x: "-50%" }}
        exit={{ opacity: 0, y: 14, x: "-50%" }}
        transition={{ duration: 0.18 }} data-testid="bulk-toolbar"
        className="absolute bottom-14 left-1/2 z-30 flex max-w-[calc(100%-2rem)] flex-wrap items-center gap-2 rounded-full border border-[#2f2f2f] bg-[rgba(20,20,20,0.94)] px-4 py-2 shadow-[0_18px_50px_-12px_rgba(0,0,0,0.9)] backdrop-blur-xl">
        <span className="text-[12.5px] font-medium">{selected.size} selected</span>
        <div className="ml-2 flex flex-wrap gap-1.5">
          <Button size="sm" onClick={() => onBulk("approve")} data-testid="bulk-approve-button"
            className="h-7 bg-[#22C55E] px-3 text-[12px] font-medium text-black hover:bg-[#2fd66c]">
            <CheckCircle2 size={12} className="mr-1" /> Approve
          </Button>
          <Button size="sm" variant="outline" onClick={() => onBulk("reject")} data-testid="bulk-reject-button"
            className="h-7 border-0 bg-[rgba(239,68,68,0.12)] px-3 text-[12px] text-[#F87171] hover:bg-[rgba(239,68,68,0.24)] hover:text-[#F87171]">
            <XCircle size={12} className="mr-1" /> Reject
          </Button>
          <Button size="sm" variant="outline" onClick={() => onBulk("export")} data-testid="bulk-export-button"
            className="h-7 border-0 bg-[#1c1c1c] px-3 text-[12px] text-[#A3A3A3] hover:bg-[#242424] hover:text-white">
            <ArrowUpRight size={12} className="mr-1" /> Export
          </Button>
          <Button size="sm" variant="outline" onClick={() => onBulk("message")} data-testid="bulk-message-button"
            className="h-7 border-0 bg-[#1c1c1c] px-3 text-[12px] text-[#A3A3A3] hover:bg-[#242424] hover:text-white">
            <Send size={12} className="mr-1" /> Message employee
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button size="sm" variant="outline" data-testid="bulk-assign-button"
                className="h-7 border-0 bg-[rgba(79,142,247,0.12)] px-3 text-[12px] text-[#7FAEF9] hover:bg-[rgba(79,142,247,0.24)] hover:text-[#7FAEF9]">
                <UserCheck size={12} className="mr-1" /> Assign to
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-52 border-[#222] bg-[#161616] text-white" data-testid="bulk-assign-menu">
              {members.map((m) => (
                <DropdownMenuItem key={m.id} onClick={() => onAssign(m.id)} data-testid={`bulk-assign-option-${m.id}`}
                  className="text-[12px] focus:bg-[#1f1f1f] focus:text-white">
                  {m.name} <span className="ml-auto text-[10px] text-[#6b6b6b]">{m.role}</span>
                </DropdownMenuItem>
              ))}
              <DropdownMenuSeparator className="bg-[#222]" />
              <DropdownMenuItem onClick={() => onAssign(null)} data-testid="bulk-assign-unassign"
                className="text-[12px] text-[#6b6b6b] focus:bg-[#1f1f1f] focus:text-white">
                Unassign
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <button onClick={onClear} className="ml-1 text-[11.5px] text-[#6b6b6b] hover:text-white" data-testid="bulk-clear-button">
          Clear
        </button>
      </motion.div>
    )}
  </AnimatePresence>
);
